/**
 * Sanitiza número de documento removendo todos os caracteres especiais.
 * Mantém apenas letras (A-Z, a-z) e números (0-9).
 *
 * Exemplos:
 * - "MG-123456" → "MG123456"
 * - "@MG123456" → "MG123456"
 * - "ABC/1232-2" → "ABC12322"
 * - " @#$%ABC123" → "ABC123"
 * - "ABC123" → "ABC123"
 *
 * @param value - String de número de documento com possíveis caracteres especiais
 * @returns String sanitizada contendo apenas caracteres alfanuméricos
 */
export function sanitizeDocumentNumber(value: string): string {
  if (!value) {
    return '';
  }
  // Remove todos os caracteres que não sejam letras (A-Z, a-z) ou números (0-9)
  return value.replace(/[^a-zA-Z0-9]/g, '');
}
